import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { $, append } from 'vscode/vscode/vs/base/browser/dom';
import { parseLinkedText } from 'vscode/vscode/vs/base/common/linkedText';
import Severity$1 from 'vscode/vscode/vs/base/common/severity';
import { SeverityIcon } from 'vscode/vscode/vs/platform/severityIcon/browser/severityIcon';
import { TextSearchCompleteMessageType } from 'vscode/vscode/vs/workbench/services/search/common/searchExtTypes';
import { Schemas } from 'vscode/vscode/vs/base/common/network';
import { Link } from 'vscode/vscode/vs/platform/opener/browser/link';
import { URI } from 'vscode/vscode/vs/base/common/uri';

const _moduleId = "vs/workbench/contrib/search/browser/searchMessage";
const renderSearchMessage = (message, instantiationService, notificationService, openerService, commandService, disposableStore, triggerSearch) => {
    const div = $('div.providerMessage');
    const linkedText = parseLinkedText(message.text);
    append(div, $('.' +
        SeverityIcon.className(message.type === TextSearchCompleteMessageType.Information
            ? Severity$1.Info
            : Severity$1.Warning)
            .split(' ')
            .join('.')));
    for (const node of linkedText.nodes) {
        if (typeof node === 'string') {
            append(div, document.createTextNode(node));
        }
        else {
            const link = instantiationService.createInstance(Link, div, node, {
                opener: async (href) => {
                    if (!message.trusted) {
                        return;
                    }
                    const parsed = ( (URI.parse(href, true)));
                    if (parsed.scheme === Schemas.command && message.trusted) {
                        const result = await commandService.executeCommand(parsed.path);
                        if (result?.triggerSearch) {
                            triggerSearch();
                        }
                    }
                    else if (parsed.scheme === Schemas.https) {
                        openerService.open(parsed);
                    }
                    else {
                        if (parsed.scheme === Schemas.command && !message.trusted) {
                            notificationService.error(( localizeWithPath(
                                _moduleId,
                                0,
                                "Unable to open command link from untrusted source: {0}",
                                href
                            )));
                        }
                        else {
                            notificationService.error(( localizeWithPath(_moduleId, 1, "Unable to open unknown link: {0}", href)));
                        }
                    }
                }
            });
            disposableStore.add(link);
        }
    }
    return div;
};

export { renderSearchMessage };
